<template>
  <div id="condition">
    <div class="top-title border-b border-section_border" id="top-title">
      <h1 class="top-title-heading" v-html="$t('tour_main_title')"></h1>
    </div>
    <div class="plan-condition py-4 bg-light_gray border-b border-section_border">
      <h2 class="section-title mb-2 px-4 text-center text-lg">
        {{ $t('tour_plan_create_title') }}
      </h2>
      <div id="conditionVisible">
        <div class="mb-4 px-4">
          <departure-datetime-select v-model="datetime" class="mb-4" />
        </div>
        <div class="mt-6 px-4">
          <a @click="handleClick" class="button-primary block">{{ $t('tour_set_conditions_label') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DepartureDatetimeSelect from '../molecules/DepatureDatetimeSelect'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo');

export default {
  components: {
    DepartureDatetimeSelect
  },
  computed: {
    datetime: {
      get () {
        return this.$store.getters['condition/getTime']
      },
      set (value) {
        this.$store.dispatch('condition/updateTime', value)
      }
    }
  },
  methods: {
    handleClick: function () {
      this.$store.dispatch('routes/search')
    }
  }
}
</script>
